module.exports = "/_next/static/images/logo-light-en-dcfe689be62e07c1f8c2d898d397a81c.png";